import moment from 'moment';
import React from 'react';

import DownloadButton from '@/components/UI/DownloadButton';

const DownloadExcel: React.FC<{ example?: boolean }> = ({
  example = false,
  children,
}) => {
  return (
    <DownloadButton
      {...{
        url: '/ezcon/api/getExampleOrRealDataExcel',
        headers: {
          authorization: localStorage.getItem('feathers-jwt'),
        },
        params: {
          excelName: 'maintenanceManagementEquipmentInventoryExcel',
          example,
        },
        fileName: `${'維運管理資(耗)材設備管理庫存表單'}_${moment().format(
          'YYYYMMDD'
        )}.xlsx`,
        responseFileType: 'blob',
      }}
    >
      {children}
    </DownloadButton>
  );
};

export default DownloadExcel;
